export default __webpack_public_path__ + "static/media/julia4.3be62f10.png";